import Label from "react-bootstrap/lib/Label";
import Text from "./Text";

const ParamLabel = ({ param, className }) => {
    return (
        <Label className={className}>
            <Text param={param} />
        </Label>
    );
};

ParamLabel.displayName = "SearchParam.Label";
export default ParamLabel;
